// Lib
import { clamp } from 'lodash/fp';

// Constants
import { DIRECTION } from '../pointerConstants';

const clampHorizontal = (layerRect, pointerRect, margin) =>
    clamp(layerRect.left + margin, layerRect.right - (pointerRect.width + margin));
const clampVertical = (layerRect, pointerRect, margin) =>
    clamp(layerRect.top + margin, layerRect.bottom - (pointerRect.height + margin));

const positionContentAbove = ({ targetPoint, targetRect, pointerRect, margin }) => {
    const targetY = targetPoint ? targetPoint.y : targetRect.top;
    const targetX = targetPoint ? targetPoint.x : (targetRect.right + targetRect.left) / 2;

    return {
        top: targetY - (pointerRect.height + margin),
        left: targetX - pointerRect.width / 2,
    };
};
/**
 * The clamp will correct the content's location here
 */
const positionContentToCenter = ({ targetPoint, targetRect, pointerRect, margin }) => {
    const targetY = targetPoint ? targetPoint.y : (targetRect.top + targetRect.bottom) / 2;
    const targetX = targetPoint ? targetPoint.x : (targetRect.right + targetRect.left) / 2;

    return {
        top: targetY - (pointerRect.height + margin),
        left: targetX - pointerRect.width / 2,
    };
};

const positionContentToRight = ({ targetPoint, targetRect, pointerRect, margin }) => {
    const targetY = targetPoint ? targetPoint.y : (targetRect.top + targetRect.bottom) / 2;
    const targetX = targetPoint ? targetPoint.x : targetRect.right;

    return {
        top: targetY - pointerRect.height / 2,
        left: targetX + margin,
    };
};

const positionContentBelow = ({ targetPoint, targetRect, pointerRect, margin }) => {
    const targetY = targetPoint ? targetPoint.y : targetRect.bottom;
    const targetX = targetPoint ? targetPoint.x : (targetRect.right + targetRect.left) / 2;

    return {
        top: targetY + margin,
        left: targetX - pointerRect.width / 2,
    };
};

const positionContentToLeft = ({ targetPoint, targetRect, pointerRect, margin }) => {
    const targetY = targetPoint ? targetPoint.y : (targetRect.top + targetRect.bottom) / 2;
    const targetX = targetPoint ? targetPoint.x : targetRect.left;

    return {
        top: targetY - pointerRect.height / 2,
        left: targetX - (pointerRect.width + margin),
    };
};

const CONTENT_POSITION_FNS = {
    [DIRECTION.NORTH]: positionContentBelow,
    [DIRECTION.NORTH_EAST]: positionContentToCenter,
    [DIRECTION.EAST]: positionContentToLeft,
    [DIRECTION.SOUTH_EAST]: positionContentToCenter,
    [DIRECTION.SOUTH]: positionContentAbove,
    [DIRECTION.SOUTH_WEST]: positionContentToCenter,
    [DIRECTION.WEST]: positionContentToRight,
    [DIRECTION.NORTH_WEST]: positionContentToCenter,
};

/**
 * Returns an offset from the origin of the layer.
 */
export default ({ targetPoint, targetRect, pointerRect, layerRect, arrowRect, pointerDirection, margin }) => {
    const topClamp = clampVertical(layerRect, pointerRect, margin);
    const leftClamp = clampHorizontal(layerRect, pointerRect, margin);

    const positionFn = CONTENT_POSITION_FNS[pointerDirection];

    // Get the position of the tooltip if it existed on the infinite canvas
    const unClampedPosition = positionFn({ targetPoint, targetRect, pointerRect, margin });

    // Clamp the tooltip to the dimensions of the layer it's sitting on
    return {
        top: Math.round(topClamp(unClampedPosition.top)),
        left: Math.round(leftClamp(unClampedPosition.left)),
    };
};
